const initJumpButton = () => {
	const jumpButton = document.querySelector('.jump-button');
	if (jumpButton) {
		let isVisible = false;
		document.addEventListener('scroll', (evt) => {
			if (!isVisible && window.scrollY > 480) {
				jumpButton.classList.add('jump-button--active');
				isVisible = !isVisible;
			} else if (isVisible && window.scrollY < 480) {
				jumpButton.classList.remove('jump-button--active');
				isVisible = !isVisible;
			}
		});
		
		jumpButton.addEventListener('click', (evt) => {
			window.scrollTo(0, 0);
		});
	}
};

export default initJumpButton;
